import { render, staticRenderFns } from "./WebGL.vue?vue&type=template&id=cb8c10a2&scoped=true&"
import script from "./WebGL.vue?vue&type=script&lang=js&"
export * from "./WebGL.vue?vue&type=script&lang=js&"
import style0 from "./WebGL.vue?vue&type=style&index=0&id=cb8c10a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8c10a2",
  null
  
)

export default component.exports